module.exports = __webpack_public_path__ + "static/img/school-red@2x.abeca23.png";